import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6974890b1beda8001431b7d4_1783668689291_ac16b3ac/moyak_gloria_wedding/src/app/admin-login/page.tsx");
